var module = angular.module('octopusApp.configuration');

module.directive('private', function() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<div><button type="button" class="btn btn-link" ng-show="isPrivate" ng-click="show()">Show &raquo;</button><div class="transcluded" ng-hide="isPrivate" ng-transclude></div></div>',
    scope: { },
    link: function (scope, element, attrs) {
      scope.isPrivate = true;
      scope.show = function() {
        scope.isPrivate = false;
      };
    }
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/directives/private.js
// module id = 6419657243642318
// module chunks = 1